import type { Locale } from '@/utils/locale'

const languageNames: Record<Locale, string> = {
  de: 'German',
  en: 'English',
  fr: 'French',
  nl: 'Dutch',
  debug: 'German',
}

export function buildMcpPrompt(prompt: string, locale: Locale): string {
  const language = languageNames[locale]

  return `[The user interface language is ${language}. Respond in ${language} unless the user explicitly asks for another language.]\n\n${prompt}`
}